import { PlumbingProduct } from '@common/models';
import { createFetchProductsHook } from '@core/utils/createFetchProductsHook';
import { useFetchPlumbingQuery } from '@ee-api/plumbing-api/plumbingService';

type UsePlumbingReturn = ReturnType<typeof _usePlumbing> & {
    data?: PlumbingProduct[];
    plumbingItems: PlumbingProduct[];
    isFetchingPlumbing: boolean;
};

const emptyArray = [] satisfies PlumbingProduct[];

const _usePlumbing = createFetchProductsHook({
    apiQueryHook: useFetchPlumbingQuery,
});

export const usePlumbing = (): UsePlumbingReturn => {
    return _usePlumbing({
        selectFromResult: (result) => {
            return {
                plumbingItems: result.isSuccess && result.data ? result.data : emptyArray, // T
                isFetchingPlumbing: result.isFetching,
                ...result,
            };
        },
    });
};
